(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["onera-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-onera-announcement]');
    if (!root) return;

    var track = root.querySelector('[data-onera-announcement-track]');
    var slides = root.querySelectorAll('[data-onera-announcement-slide]');
    if (!track || !slides.length) return;

    var FIT_MAX = 11;
    var FIT_MIN = 7;
    var FIT_STEP = 0.25;
    var index = 0;
    var timer = null;
    var fitRaf = 0;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var desktopQuery = window.matchMedia('(min-width: 768px)');

    var setHeight = function () {
      var active = root.querySelector('[data-onera-announcement-slide].is-active') || slides[index] || slides[0];
      if (!active) return;
      root.style.setProperty('--onera-announcement-height', active.offsetHeight + 'px');
    };

    var fitMessage = function (message) {
      if (!message) return;
      var size = FIT_MAX;
      message.style.fontSize = size + 'px';

      while (message.scrollWidth > message.clientWidth - 2 && size > FIT_MIN) {
        size = Math.max(FIT_MIN, +(size - FIT_STEP).toFixed(2));
        message.style.fontSize = size + 'px';
      }
    };

    var fitAll = function () {
      var messages = root.querySelectorAll('.onera-announcement__message');
      var isDesktop = desktopQuery.matches;

      for (var i = 0; i < messages.length; i++) {
        if (isDesktop) {
          // Let CSS clamp handle desktop — restore original max size.
          messages[i].style.fontSize = '';
        } else {
          fitMessage(messages[i]);
        }
      }
      setHeight();
    };

    var scheduleFit = function () {
      if (fitRaf) window.cancelAnimationFrame(fitRaf);
      fitRaf = window.requestAnimationFrame(function () {
        fitRaf = 0;
        fitAll();
      });
    };

    fitAll();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleFit).catch(function () {});
    }

    window.addEventListener('resize', scheduleFit, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var fitObserver = new ResizeObserver(scheduleFit);
      fitObserver.observe(root);
    }

    if (slides.length < 2) return;

    var interval = parseInt(root.getAttribute('data-onera-announcement-autoplay'), 10);
    if (!interval || interval < 2000) return;

    var show = function (nextIndex) {
      slides[index].classList.remove('is-active');
      index = nextIndex;
      slides[index].classList.add('is-active');
      scheduleFit();
    };

    var tick = function () {
      show((index + 1) % slides.length);
    };

    var start = function () {
      if (reducedMotion) return;
      stop();
      timer = window.setInterval(tick, interval);
    };

    var stop = function () {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    start();

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onera-header"]) return;
  try {
    
  (function () {
    var SCROLL_THRESHOLD = 12;
    var HIDE_AFTER = 72;
    var HOVER_ZONE = 72;
    var HIDE_DELAY_MS = 1400;
    var HERO_BLUR_RATIO = 0.48;

    var initHeaderState = function () {
      var header = document.querySelector('[data-onera-header]');
      if (!header) return;

      var wrapper = header.closest('.onera-header-wrapper') || header.parentElement;
      var overlayEnabled = header.getAttribute('data-onera-header-overlay') === 'true';
      var hero = document.querySelector('[data-onera-hero-overlay]');
      var canOverlay = overlayEnabled && !!hero;
      var lastY = window.scrollY || 0;
      var hideTimer = null;
      var pointerNear = false;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      var setSolid = function () {
        header.classList.remove('onera-header--overlay');
        header.classList.add('onera-header--solid', 'onera-header--scrolled');
      };

      var setOverlay = function () {
        header.classList.add('onera-header--overlay');
        header.classList.remove('onera-header--solid', 'onera-header--scrolled');
      };

      var setOverlayScrolled = function () {
        header.classList.add('onera-header--overlay', 'onera-header--scrolled');
        header.classList.remove('onera-header--solid');
      };

      /* Frosted header only once scroll reaches ~halfway down the hero. */
      var getHeroBlurAt = function () {
        if (!hero) return SCROLL_THRESHOLD;
        var height = hero.offsetHeight || 0;
        if (height < 120) return SCROLL_THRESHOLD;
        return Math.max(SCROLL_THRESHOLD, Math.round(height * HERO_BLUR_RATIO));
      };

      var clearHideTimer = function () {
        if (hideTimer) {
          window.clearTimeout(hideTimer);
          hideTimer = null;
        }
      };

      var showHeader = function () {
        clearHideTimer();
        header.classList.remove('onera-header--hidden');
        if (wrapper) wrapper.classList.remove('is-header-hidden');
      };

      var hideHeader = function () {
        if (reduceMotion.matches) return;
        header.classList.add('onera-header--hidden');
        if (wrapper) wrapper.classList.add('is-header-hidden');
      };

      var scheduleHide = function () {
        clearHideTimer();
        if (pointerNear || window.scrollY <= HIDE_AFTER) {
          showHeader();
          return;
        }
        hideTimer = window.setTimeout(function () {
          if (!pointerNear && window.scrollY > HIDE_AFTER) hideHeader();
        }, HIDE_DELAY_MS);
      };

      var syncForcedStates = function () {
        var forcedSolid =
          document.body.classList.contains('onera-search-open') ||
          document.querySelector('[data-onera-drawer].is-open') ||
          document.querySelector('[data-onera-cart-drawer].is-open');

        if (forcedSolid) {
          header.classList.add('onera-header--forced-solid');
          showHeader();
          return true;
        }

        header.classList.remove('onera-header--forced-solid');
        return false;
      };

      var syncScrollState = function () {
        if (syncForcedStates()) {
          lastY = window.scrollY || 0;
          return;
        }

        var y = window.scrollY || 0;
        var goingDown = y > lastY + 2;
        var goingUp = y < lastY - 2;
        var blurAt = getHeroBlurAt();

        if (!canOverlay) {
          if (y > SCROLL_THRESHOLD) {
            header.classList.add('onera-header--scrolled');
          } else {
            header.classList.remove('onera-header--scrolled');
          }
        } else if (y < blurAt) {
          setOverlay();
        } else {
          setOverlayScrolled();
        }

        if (y <= HIDE_AFTER || goingUp || pointerNear) {
          showHeader();
        } else if (goingDown && y >= blurAt) {
          scheduleHide();
        }

        lastY = y;
      };

      if (canOverlay) {
        header.classList.remove('onera-header--solid');
        header.classList.add('onera-header--overlay');
      } else {
        header.classList.remove('onera-header--overlay');
        header.classList.add('onera-header--solid');
      }

      syncScrollState();
      window.addEventListener('scroll', syncScrollState, { passive: true });
      window.addEventListener('resize', syncScrollState, { passive: true });

      document.addEventListener(
        'mousemove',
        function (event) {
          var near = event.clientY <= HOVER_ZONE;
          if (near === pointerNear) return;
          pointerNear = near;
          if (pointerNear) {
            showHeader();
          } else if (window.scrollY > HIDE_AFTER) {
            scheduleHide();
          }
        },
        { passive: true }
      );

      header.addEventListener('mouseenter', function () {
        pointerNear = true;
        showHeader();
      });
      header.addEventListener('mouseleave', function () {
        pointerNear = false;
        if (window.scrollY > HIDE_AFTER) scheduleHide();
      });

      if (typeof MutationObserver !== 'undefined') {
        var stateObserver = new MutationObserver(syncScrollState);
        stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        var drawerEl = document.querySelector('[data-onera-drawer]');
        var cartEl = document.querySelector('[data-onera-cart-drawer]');
        if (drawerEl) {
          stateObserver.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
        }
        if (cartEl) {
          stateObserver.observe(cartEl, { attributes: true, attributeFilter: ['class'] });
        }
      }

      var measure = function () {
        var announcement = document.querySelector('[data-onera-announcement]');
        var announcementHeight = 0;
        if (announcement && announcement.offsetParent !== null) {
          announcementHeight = announcement.offsetHeight;
        }
        var wasHidden = header.classList.contains('onera-header--hidden');
        if (wasHidden) header.classList.remove('onera-header--hidden');
        var headerHeight = header.offsetHeight;
        if (wasHidden) header.classList.add('onera-header--hidden');
        document.documentElement.style.setProperty(
          '--onera-announcement-height',
          announcementHeight + 'px'
        );
        document.documentElement.style.setProperty(
          '--header-height',
          headerHeight + 'px'
        );
        document.documentElement.style.setProperty(
          '--onera-site-header-offset',
          announcementHeight + headerHeight + 'px'
        );
      };

      measure();
      window.addEventListener('resize', measure, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        var resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(header);
        var announcementEl = document.querySelector('[data-onera-announcement]');
        if (announcementEl) resizeObserver.observe(announcementEl);
      }
    };

    var initDrawer = function () {
      var drawer = document.querySelector('[data-onera-drawer]');
      if (!drawer) return;

      var openBtn = document.querySelector('[data-onera-drawer-open]');
      var closeEls = drawer.querySelectorAll('[data-onera-drawer-close]');
      var panel = drawer.querySelector('.onera-drawer__panel');
      var closeBtn = drawer.querySelector('.onera-drawer__close');
      var lastFocused = null;

      var lockScroll = function () {
        if (typeof window.oneraScrollLock === 'function') {
          window.oneraScrollLock();
        } else {
          document.documentElement.classList.add('onera-no-scroll');
        }
      };

      var unlockScroll = function () {
        if (typeof window.oneraScrollUnlock === 'function') {
          window.oneraScrollUnlock();
        } else {
          document.documentElement.classList.remove('onera-no-scroll');
        }
      };

      var open = function () {
        if (typeof window.oneraCloseCartDrawer === 'function') {
          window.oneraCloseCartDrawer(true);
        }
        if (typeof window.oneraCloseSearch === 'function') {
          window.oneraCloseSearch(true);
        }
        lastFocused = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        lockScroll();
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        document.dispatchEvent(new CustomEvent('onera:nav:open'));
        if (closeBtn) {
          window.setTimeout(function () {
            closeBtn.focus();
          }, 60);
        }
      };

      var close = function (instant) {
        if (!drawer.classList.contains('is-open')) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        unlockScroll();
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.dispatchEvent(new CustomEvent('onera:nav:close'));
        if (!instant && lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      };

      window.oneraCloseNavDrawer = close;
      window.oneraOpenNavDrawer = open;

      if (openBtn) openBtn.addEventListener('click', open);
      closeEls.forEach(function (el) {
        el.addEventListener('click', function () {
          close();
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
          close();
        }
      });

      document.addEventListener('onera:cart:open', function () {
        close(true);
      });

      drawer.querySelectorAll('[data-onera-submenu-toggle]').forEach(function (toggle) {
        var submenuId = toggle.getAttribute('aria-controls');
        var submenu = submenuId ? document.getElementById(submenuId) : null;
        if (!submenu) return;

        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          submenu.classList.toggle('is-open', !expanded);
        });
      });

      if (panel) {
        panel.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    };

    var initDesktopDropdowns = function () {
      var groups = document.querySelectorAll('.onera-nav__group');
      if (!groups.length) return;

      groups.forEach(function (group) {
        var trigger = group.querySelector('.onera-nav__link');
        var panel = group.querySelector('.onera-nav__dropdown');
        if (!trigger || !panel) return;

        var open = function () {
          panel.hidden = false;
          group.classList.add('is-open');
        };

        var close = function () {
          panel.hidden = true;
          group.classList.remove('is-open');
        };

        group.addEventListener('mouseenter', open);
        group.addEventListener('mouseleave', close);
        group.addEventListener('focusin', open);
        group.addEventListener('focusout', function (event) {
          if (!group.contains(event.relatedTarget)) close();
        });
      });
    };

    var initCartCount = function () {
      var badges = document.querySelectorAll('[data-onera-cart-count]');
      var desktopLabel = document.querySelector('[data-onera-cart-desktop-label]');
      if (!badges.length && !desktopLabel) return;

      var render = function (count) {
        badges.forEach(function (badge) {
          badge.textContent = count;
          badge.classList.toggle('is-empty', count === 0);
        });
        if (desktopLabel) {
          desktopLabel.textContent = count > 0 ? ' (' + count + ')' : '';
        }
      };

      var syncFromEvent = function (event) {
        if (
          event.detail &&
          event.detail.cart &&
          typeof event.detail.cart.item_count === 'number'
        ) {
          render(event.detail.cart.item_count);
          return true;
        }
        return false;
      };

      var refresh = function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(function (cart) {
            if (cart && typeof cart.item_count === 'number') {
              render(cart.item_count);
            }
          })
          .catch(function () {});
      };

      window.oneraUpdateCartCount = render;

      window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
          refresh();
          return;
        }
        try {
          var entries = performance.getEntriesByType('navigation');
          if (entries.length && entries[0].type === 'back_forward') {
            refresh();
          }
        } catch (error) {}
      });

      document.addEventListener('onera:cart:added', function (event) {
        syncFromEvent(event);
      });
      document.addEventListener('onera:cart:changed', function (event) {
        syncFromEvent(event);
      });
      document.addEventListener('onera:cart:updated', function (event) {
        if (!syncFromEvent(event)) refresh();
      });
    };

    var init = function () {
      initHeaderState();
      initDrawer();
      initDesktopDropdowns();
      initCartCount();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
